export const environments = {
  CI: 'CI',
  DEV: 'dev',
  PROD: 'production',
  STAGING: 'staging',
  TEST: 'test',
};

export const oldUserStates = {
  ACTIVE: {
    value: 'ACTIVE',
    display: {
      selectValue: 'Profils actifs',
      shortValue: 'Actif',
    },
  },
  CURRENT_YEAR_STUDENTS: {
    value: 'CURRENT_YEAR_STUDENTS',
    display: {
      selectValue: 'Total étudiants',
      shortValue: 'étudiants inscrits',
    },
  },
  CREATED: {
    value: 'CREATED',
    display: {
      selectValue: 'En attente de validations de mail',
      shortValue: 'Mail non confirmé',
    },
  },
  LEARNING: {
    value: 'LEARNING',
    display: {
      selectValue: 'Candidats master en cours de renforcement',
      shortValue: 'En renforcement',
    },
  },
  VALID_APPLICATION: {
    value: 'VALID_APPLICATION',
    display: {
      selectValue: 'Dossier master en attente de sélection',
      shortValue: 'Validé',
    },
  },
  SELECTED: {
    value: 'SELECTED',
    display: {
      selectValue:
        'Dossier master en attente de paiement de frais de cours de renforcement',
      shortValue: 'En attente de paiement renforcement',
    },
  },
  CURRENT_YEAR_PUPILS: {
    value: 'CURRENT_YEAR_PUPILS',
    display: {
      selectValue: 'Total élèves (F4)',
      shortValue: 'élèves inscrits',
    },
  },
  APPLYING: {
    value: 'APPLYING',
    display: {
      selectValue: 'Dossiers non soumis',
      shortValue: 'Non soumis',
    },
  },
  SUBMITTED: {
    value: 'SUBMITTED',
    display: {
      selectValue: 'Dossiers soumis',
      shortValue: 'Soumis',
    },
  },
  REJECTED: {
    value: 'REJECTED',
    display: {
      selectValue: 'Dossiers rejetés',
      shortValue: 'Rejeté',
    },
  },
  CONFIRMED: {
    value: 'CONFIRMED',
    display: {
      selectValue: "Dossiers en attente de paiement des frais d'inscription",
      shortValue: 'En attente de paiement inscription',
    },
  },
  DEACTIVATED: {
    value: 'DEACTIVATED',
    display: {
      selectValue: 'Profils inactifs',
      shortValue: 'Non actifs',
    },
  },
  TOTAL: {
    value: 'TOTAL',
    display: {
      selectValue: 'Total inscriptions',
      shortValue: 'Étudiants',
    },
  },
  CURRENT_REGISTER: {
    value: 'CURRENT_REGISTER',
    display: {
      selectValue: 'Inscrits cette année',
      shortValue: 'Nouveaux',
    },
  },
};

export const userStates = {
  ACTIVE: {
    value: 'ACTIVE',
    display: {
      selectValue: 'Profils actifs',
      shortValue: 'Actif',
    },
  },
  CREATED: {
    value: 'CREATED',
    display: {
      selectValue: 'En attente de validations de mail',
      shortValue: 'Mail non confirmé',
    },
  },
  SUBMITTED: {
    value: 'SUBMITTED',
    display: {
      selectValue: 'Dossiers en attente de validation',
      shortValue: 'En attente de validation',
    },
  },
  CONFIRMED: {
    value: 'CONFIRMED',
    display: {
      selectValue: 'Dossiers incomplets',
      shortValue: 'Non soumis',
    },
  },
  DEACTIVED: {
    value: 'DEACTIVED',
    display: {
      selectValue: 'Profils désactivés',
      shortValue: 'désactivé',
    },
  },
  ARCHIVED: {
    value: 'ARCHIVED',
    display: {
      selectValue: 'Profils archivés',
      shortValue: 'comptes archivés',
    },
  },
};

/*
 * LES ÉTATS QUI OUVRENT « MES RATTRAPAGES ».
 *
 * Écrit ICI, et non dans chaque barre latérale : la liste vivait en deux
 * exemplaires — bureau et mobile — et une liste dupliquée finit par
 * diverger. La copie oubliée montrerait l'entrée à quelqu'un qui ne doit
 * pas la voir, ou la cacherait à quelqu'un qui en a besoin ; et le défaut
 * ne se verrait que sur un seul des deux formats d'écran.
 *
 * RECETTE 2026-08-14 — CE MENU N'EST PAS POUR UN COMPTE NEUF.
 *
 * Il n'avait au départ AUCUNE garde d'état, à dessein : un étudiant
 * DÉSACTIVÉ doit pouvoir régler ses rattrapages, c'est souvent sa voie de
 * régularisation. `ARCHIVED` suit la même logique.
 *
 * Ce qu'on écarte est le seul cas qui n'a rien à y faire : le compte tout
 * juste créé — mail non confirmé, dossier non validé — qui n'a ni
 * scolarité derrière lui ni rattrapage à payer. Lui montrer l'entrée
 * l'envoyait vers un écran vide.
 */
export const ETATS_AVEC_RATTRAPAGES = [
  userStates.ACTIVE.value,
  userStates.DEACTIVED.value,
  userStates.ARCHIVED.value,
];

export const userTypeEnum = {
  ADMIN: 'admin',
  AGENT: 'agent',
  SUPERVISOR: 'supervisor',
  VISITOR: 'visitor',
  PROFESSOR: 'professor',
  STUDENT: 'student',
  SUPERADMIN: 'superadmin',
};

export const cyclesEnum = ['SECONDAIRE', 'LICENCE', 'MASTER'];

export const nationalityList = [
  'Afghane',
  'Albanaise',
  'Algérienne',
  'Allemande',
  'Américaine',
  'Andorrane',
  'Angolaise',
  'Antiguaise-et-Barbudienne',
  'Argentine',
  'Arménienne',
  'Australienne',
  'Autrichienne',
  'Azerbaïdjanaise',
  'Bahamienne',
  'Bahreinienne',
  'Bangladaise',
  'Barbadienne',
  'Belge',
  'Belizienne',
  'Béninoise',
  'Bhoutanaise',
  'Biélorusse',
  'Birmane',
  'Bissau-Guinéenne',
  'Bolivienne',
  'Bosnienne',
  'Botswanaise',
  'Brésilienne',
  'Britannique',
  'Brunéienne',
  'Bulgare',
  'Burkinabée',
  'Burundaise',
  'Cambodgienne',
  'Camerounaise',
  'Canadienne',
  'Cap-verdienne',
  'Centrafricaine',
  'Chilienne',
  'Chinoise',
  'Chypriote',
  'Colombienne',
  'Comorienne',
  'Congolaise',
  'Congolaise',
  'Cookienne',
  'Costaricaine',
  'Croate',
  'Cubaine',
  'Danoise',
  'Djiboutienne',
  'Dominicaine',
  'Dominiquaise',
  'Égyptienne',
  'Émirienne',
  'Équato-guineenne',
  'Équatorienne',
  'Érythréenne',
  'Espagnole',
  'Est-timoraise',
  'Estonienne',
  'Éthiopienne',
  'Fidjienne',
  'Finlandaise',
  'Française',
  'Gabonaise',
  'Gambienne',
  'Georgienne',
  'Ghanéenne',
  'Grenadienne',
  'Guatémaltèque',
  'Guinéenne',
  'Guyanienne',
  'Haïtienne',
  'Hellénique',
  'Hondurienne',
  'Hongroise',
  'Indienne',
  'Indonésienne',
  'Irakienne',
  'Iranienne',
  'Irlandaise',
  'Islandaise',
  'Israélienne',
  'Italienne',
  'Ivoirienne',
  'Jamaïcaine',
  'Japonaise',
  'Jordanienne',
  'Kazakhstanaise',
  'Kenyane',
  'Kirghize',
  'Kiribatienne',
  'Kittitienne et Névicienne',
  'Koweïtienne',
  'Laotienne',
  'Lesothane',
  'Lettone',
  'Libanaise',
  'Libérienne',
  'Libyenne',
  'Liechtensteinoise',
  'Lituanienne',
  'Luxembourgeoise',
  'Macédonienne',
  'Malaisienne',
  'Malawienne',
  'Maldivienne',
  'Malgache',
  'Maliennes',
  'Maltaise',
  'Marocaine',
  'Marshallaise',
  'Mauricienne',
  'Mauritanienne',
  'Mexicaine',
  'Micronésienne',
  'Moldave',
  'Monegasque',
  'Mongole',
  'Monténégrine',
  'Mozambicaine',
  'Namibienne',
  'Nauruane',
  'Néerlandaise',
  'Néo-Zélandaise',
  'Népalaise',
  'Nicaraguayenne',
  'Nigériane',
  'Nigérienne',
  'Niuéenne',
  'Nord-coréenne',
  'Norvégienne',
  'Omanaise',
  'Ougandaise',
  'Ouzbéke',
  'Pakistanaise',
  'Palaosienne',
  'Palestinienne',
  'Panaméenne',
  'Papouane-Néo-Guinéenne',
  'Paraguayenne',
  'Péruvienne',
  'Philippine',
  'Polonaise',
  'Portugaise',
  'Qatarienne',
  'Roumaine',
  'Russe',
  'Rwandaise',
  'Saint-Lucienne',
  'Saint-Marinaise',
  'Saint-Vincentaise et Grenadine',
  'Salomonaise',
  'Salvadorienne',
  'Samoane',
  'Santoméenne',
  'Saoudienne',
  'Sénégalaise',
  'Serbe',
  'Seychelloise',
  'Sierra-Léonaise',
  'Singapourienne',
  'Slovaque',
  'Slovène',
  'Somalienne',
  'Soudanaise',
  'Sri-Lankaise',
  'Sud-Africaine',
  'Sud-Coréenne',
  'Sud-Soudanaise',
  'Suédoise',
  'Suisse',
  'Surinamaise',
  'Swazie',
  'Syrienne',
  'Tadjike',
  'Tanzanienne',
  'Tchadienne',
  'Tchèque',
  'Thaïlandaise',
  'Togolaise',
  'Tonguienne',
  'Trinidadienne',
  'Tunisienne',
  'Turkmène',
  'Turque',
  'Tuvaluane',
  'Ukrainienne',
  'Uruguayenne',
  'Vanuatuane',
  'Vaticane',
  'Vénézuélienne',
  'Vietnamienne',
  'Yéménite',
  'Zambienne',
  'Zimbabwéenne',
];

export const countryList = [
  'Afghanistan',
  'Albanie',
  'Algérie',
  'Allemagne',
  'États-Unis',
  'Andorre',
  'Angola',
  'Antigua-et-Barbuda',
  'Argentine',
  'Arménie',
  'Australie',
  'Autriche',
  'Azerbaïdjan',
  'Bahamas',
  'Bahreïn',
  'Bangladesh',
  'Barbade',
  'Belgique',
  'Belize',
  'Bénin',
  'Bhoutan',
  'Biélorussie',
  'Birmanie',
  'Guinée-Bissau',
  'Bolivie',
  'Bosnie-Herzégovine',
  'Botswana',
  'Brésil',
  'Royaume-Uni',
  'Brunéi',
  'Bulgarie',
  'Burkina',
  'Burundi',
  'Cambodge',
  'Cameroun',
  'Canada',
  'Cap-Vert',
  'Centrafrique',
  'Chili',
  'Chine',
  'Chypre',
  'Colombie',
  'Comores',
  'Congo-Kinshasa',
  'Congo-Brazzaville',
  'Îles Cook',
  'Costa Rica',
  'Croatie',
  'Cuba',
  'Danemark',
  'Djibouti',
  'République dominicaine',
  'Dominique',
  'Égypte',
  'Émirats arabes unis',
  'Guinée équatoriale',
  'Équateur',
  'Érythrée',
  'Espagne',
  'Timor-Leste',
  'Estonie',
  'Éthiopie',
  'Fidji',
  'Finlande',
  'France',
  'Gabon',
  'Gambie',
  'Géorgie',
  'Ghana',
  'Grenade',
  'Guatemala',
  'Guinée',
  'Guyana',
  'Haïti',
  'Grèce',
  'Honduras',
  'Hongrie',
  'Inde',
  'Indonésie',
  'Iraq',
  'Iran',
  'Irlande',
  'Islande',
  'Israël',
  'Italie',
  "Côte d'Ivoire",
  'Jamaïque',
  'Japon',
  'Jordanie',
  'Kazakhstan',
  'Kenya',
  'Kirghizistan',
  'Kiribati',
  'Saint-Christophe-et-Niévès',
  'Koweït',
  'Laos',
  'Lesotho',
  'Lettonie',
  'Liban',
  'Libéria',
  'Libye',
  'Liechtenstein',
  'Lituanie',
  'Luxembourg',
  'Macédoine',
  'Malaisie',
  'Malawi',
  'Maldives',
  'Madagascar',
  'Mali',
  'Malte',
  'Maroc',
  'Îles Marshall',
  'Maurice',
  'Mauritanie',
  'Mexique',
  'Micronésie',
  'Moldovie',
  'Monaco',
  'Mongolie',
  'Monténégro',
  'Mozambique',
  'Namibie',
  'Nauru',
  'Pays-Bas',
  'Nouvelle-Zélande',
  'Népal',
  'Nicaragua',
  'Nigéria',
  'Niger',
  'Niue',
  'Corée du Nord',
  'Norvège',
  'Oman',
  'Ouganda',
  'Ouzbékistan',
  'Pakistan',
  'Palaos',
  'Palestine',
  'Panama',
  'Papouasie-Nouvelle-Guinée',
  'Paraguay',
  'Pérou',
  'Philippines',
  'Pologne',
  'Portugal',
  'Qatar',
  'Roumanie',
  'Russie',
  'Rwanda',
  'Sainte-Lucie',
  'Saint-Marin',
  'Saint-Vincent-et-les Grenadines',
  'Îles Salomon',
  'Salvador',
  'Samoa',
  'Sao Tomé-et-Principe',
  'Arabie saoudite',
  'Sénégal',
  'Serbie',
  'Seychelles',
  'Sierra Leone',
  'Singapour',
  'Slovaquie',
  'Slovénie',
  'Somalie',
  'Soudan',
  'Sri Lanka',
  'Afrique du Sud',
  'Corée du Sud',
  'Soudan du Sud',
  'Suède',
  'Suisse',
  'Suriname',
  'Swaziland',
  'Syrie',
  'Tadjikistan',
  'Tanzanie',
  'Tchad',
  'Tchéquie',
  'Thaïlande',
  'Togo',
  'Tonga',
  'Trinité-et-Tobago',
  'Tunisie',
  'Turkménistan',
  'Turquie',
  'Tuvalu',
  'Ukraine',
  'Uruguay',
  'Vanuatu',
  'Vatican',
  'Venezuela',
  'Viêt Nam',
  'Yémen',
  'Zambie',
  'Zimbabwe',
];

export const allTestRooms = [
  { value: 'A1-001', label: 'A1-001', capacity: 33 },
  { value: 'A1-101', label: 'A1-101', capacity: 36 },
  { value: 'A1-102', label: 'A1-102', capacity: 36 },
  { value: 'A1-103', label: 'A1-103', capacity: 36 },
  { value: 'A1-104', label: 'A1-104', capacity: 36 },
  { value: 'A1-201', label: 'A1-201', capacity: 42 },
  { value: 'A1-202', label: 'A1-202', capacity: 32 },
  { value: 'A1-203', label: 'A1-203', capacity: 32 },
  { value: 'A1-204', label: 'A1-204', capacity: 42 },
  { value: 'A1-205', label: 'A1-205', capacity: 32 },
  { value: 'A1-301', label: 'A1-301', capacity: 36 },
  { value: 'A1-302', label: 'A1-302', capacity: 32 },
  { value: 'A1-302+A1-303', label: 'A1-302+A1-303', capacity: 70 },
  { value: 'A1-303', label: 'A1-303', capacity: 32 },
  { value: 'A1-304', label: 'A1-304', capacity: 36 },
  { value: 'A1-305', label: 'A1-305', capacity: 32 },
  { value: 'A1-306', label: 'A1-306', capacity: 32 },
  { value: 'A3-101', label: 'A3-101', capacity: 37 },
  { value: 'A3-102', label: 'A3-102', capacity: 37 },
  { value: 'A3-103', label: 'A3-103', capacity: 37 },
  { value: 'A3-104', label: 'A3-104', capacity: 37 },
  { value: 'A3-201', label: 'A3-201', capacity: 37 },
  { value: 'A3-202', label: 'A3-202', capacity: 37 },
  { value: 'A3-203', label: 'A3-203', capacity: 38 },
  { value: 'A3-204', label: 'A3-204', capacity: 37 },
  { value: 'A3-205', label: 'A3-205', capacity: 37 },
  { value: 'A3-206', label: 'A3-206', capacity: 38 },
  { value: 'A3-301', label: 'A3-301', capacity: 37 },
  { value: 'A3-302', label: 'A3-302', capacity: 37 },
  { value: 'A3-303', label: 'A3-303', capacity: 37 },
  { value: 'A3-304', label: 'A3-304', capacity: 37 },
  { value: 'A3-305', label: 'A3-305', capacity: 37 },
  { value: 'A3-306', label: 'A3-306', capacity: 37 },
  { value: 'A3-401', label: 'A3-401', capacity: 37 },
  { value: 'A3-402', label: 'A3-402', capacity: 37 },
  { value: 'A3-403', label: 'A3-403', capacity: 37 },
  { value: 'A3-404', label: 'A3-404', capacity: 37 },
  { value: 'A3-405', label: 'A3-405', capacity: 37 },
  { value: 'A3-406', label: 'A3-406', capacity: 37 },
  { value: 'AmphiA', label: 'AmphiA', capacity: 200 },
  { value: 'AmphiB', label: 'AmphiB', capacity: 200 },
  { value: 'AmphiC', label: 'AmphiC', capacity: 80 },
  { value: 'Bibliothèque', label: 'Bibliothèque', capacity: 60 },
  { value: 'ELS Annexe 1', label: 'ELS Annexe 1', capacity: 200 },
  { value: 'ELS Annexe 2', label: 'ELS Annexe 2', capacity: 200 },
  { value: 'ELS Siège', label: 'ELS Siège', capacity: 200 },
  { value: 'Laboratoire', label: 'Laboratoire', capacity: 99999 },
  {
    value: 'Laboratoire de Recherche',
    label: 'Laboratoire de Recherche',
    capacity: 20,
  },
  { value: 'Laboratoire de TP', label: 'Laboratoire de TP', capacity: 40 },
  { value: 'S-101', label: 'S-101', capacity: 60 },
  { value: 'S-102', label: 'S-102', capacity: 60 },
  { value: 'S-103', label: 'S-103', capacity: 38 },
  { value: 'S-301', label: 'S-301', capacity: 40 },
  { value: 'S-302', label: 'S-302', capacity: 40 },
  { value: 'S-303', label: 'S-303', capacity: 38 },
  { value: 'S-304', label: 'S-304', capacity: 38 },
  { value: 'S-305', label: 'S-305', capacity: 38 },
  { value: 'S-306', label: 'S-306', capacity: 38 },
  { value: 'S-401', label: 'S-401', capacity: 38 },
  { value: 'S-402', label: 'S-402', capacity: 38 },
  { value: 'S-403', label: 'S-403', capacity: 38 },
  { value: 'S-406', label: 'S-406', capacity: 38 },
  {
    value: 'Salle Informatique Annexe',
    label: 'Salle Informatique Annexe',
    capacity: 42,
  },
  {
    value: 'Salle Informatique Siège',
    label: 'Salle Informatique Siège',
    capacity: 32,
  },
  { value: 'Salle Internet', label: 'Salle Internet', capacity: 44 },
  { value: 'Sortie Pédagogique', label: 'Sortie Pédagogique', capacity: 99999 },
  { value: 'TERRAIN', label: 'TERRAIN', capacity: 99999 },
  { value: 'Visite de Chantier', label: 'Visite de Chantier', capacity: 99999 },
  {
    value: 'Visite de magasin de Scaphandrier',
    label: 'Visite de magasin de Scaphandrier',
    capacity: 99999,
  },
];

export const compositionTypes = {
  DEVOIR: 'Devoir',
  EXAM: 'Examen',
  RATTRAPAGE: 'Rattrapage',
};

export const permissions = {
  STATISTICS_ABSENCE_COMPLETION_GET:
    'Récupérer les statistiques de complétion des absences',
  STATISTICS_GRADES_GET: 'Récupérer les statistiques des notes par classe',

  MEETING_MANAGE: 'Gérer les convocations',

  STATISTICS_COORDINATOR_GET: 'Récupérer les statistiques des coordinateurs',

  ABSENCE_ADD: 'Ajouter/modifier des absences',
  ABSENCE_FOLLOWUP: 'Gérer les alertes des absences',
  ABSENCE_GET: 'Récupérer les absences',

  ADMIN_CREATE: 'Créer un administrateur',
  ADMIN_DELETE: 'Supprimer un administrateur',
  ADMIN_PERMISSIONS_ADD: 'Attribuer des permissions à un administrateur',
  ADMIN_UPDATE: 'Modifier un administrateur',

  // Permission PARTAGÉE entre AGENT et VISITOR (mêmes gardes, même besoin).
  AGENT_CREATE: 'Créer un agent ou un visiteur',
  AGENT_DELETE: 'Supprimer un agent ou un visiteur',
  AGENT_UPDATE: 'Modifier un agent ou un visiteur',

  ARTICLE_ADD: 'Ajouter un article',
  ARTICLE_DELETE: 'Supprimer un article',
  ARTICLE_PUBLISH: 'Publier un article',
  ARTICLE_UPDATE: 'Modifier un article',

  BOOKS_MANAGE: 'Gérer les livres',

  COMPOSITION_CODE_GEN: 'Générer les codes de composition',
  COMPOSITION_CREATE: 'Créer des compositions',
  COMPOSITION_GET: 'Récupérer la liste des compositions',
  COMPOSITION_GEN_PAYMENT_LIST:
    'Générer la liste de ceux qui ont payé un rattrapage',
  COMPOSITION_STUDENT_AUTHORIZE: 'Autoriser un étudiant(composition)',
  COMPOSITION_STUDENT_DELETE: 'Supprimer un étudiant(composition)',
  COMPOSITION_STUDENT_DISTRIBUTE: 'Répartition des étudiants dans les salles',
  COMPOSITION_STUDENT_PAY: 'Valider un payement étudiant(composition)',
  COMPOSITION_UPDATE: 'Modifier une composition',

  COURSE_ADD: 'Ajouter un cours',
  COURSE_DELETE: 'Supprimer un cours',
  COURSE_PUBLISH: 'Publier un cours',
  COURSE_UPDATE: 'Modifier un cours',

  ALUMNI_MANAGE: 'Gérer les alumnis',

  INTERNSHIP_MANAGE: 'Gérer les stagiaires',

  CYCLE_MANAGE: 'Gérer les Cycles de formation',

  EVENT_MANAGE: 'Gérer les événements',

  FAQ_MANAGE: 'Gérer la FAQ',

  FIELDS_MANAGE: 'Gérer les filières',

  GALERY_MANAGE: 'Gérer la GALERY',

  HISTORY_READ: 'Consulter historiques',

  LOANS_MANAGE: 'Gérer les prêts',

  OTHERPAGE_MANAGE: 'Gérer les pages',

  /*
   * 2026-08-09 — D22 : miroir front des permissions du module KKIAPAY.
   * Valeurs strictement identiques à backend/src/utils/enums.js.
   */
  PAIEMENT_RATTRAPAGE_ANNULER_EXONERATION: 'Annuler une exonération',
  PAIEMENT_RATTRAPAGE_CONSULTER: 'Consulter les paiements de rattrapage',
  PAIEMENT_RATTRAPAGE_EXONERER: 'Exonérer une matière de paiement',
  PAIEMENT_RATTRAPAGE_INITIER: 'Initier un paiement de rattrapage',

  /*
   * 2026-08-12 — D-09/D-09bis : miroir front des permissions SCOLARITÉ.
   * Valeurs strictement identiques à backend/src/utils/enums.js.
   */
  PAIEMENT_SCOLARITE_ANNULER_EXONERATION:
    'Annuler une exonération de scolarité',
  PAIEMENT_SCOLARITE_CONSULTER: 'Consulter les frais de scolarité dus',
  PAIEMENT_SCOLARITE_EXONERER: 'Exonérer des frais de scolarité',
  PAIEMENT_SCOLARITE_GENERER: "Générer les frais de scolarité d'un étudiant",
  PAIEMENT_SCOLARITE_INITIER: 'Initier un paiement de scolarité',

  PATNERSLOGOS_MANAGE: 'Gérer les logos des partenaires',

  PENALTY_MANAGE: 'Gérer les punitions',

  PROFESSOR_CREATE: 'Créer un professeur',
  PROFESSOR_DELETE: 'Supprimer un professeur',
  PROFESSOR_PASSWORD_GENERATE: 'Générer mot de passe professeur',
  PROFESSOR_SEND_MAIL: 'Envoyer un email d’inscription',
  PROFESSOR_UPDATE: 'Modifier un professeur',

  REGISTRATION_GET: 'Récupérer la liste des codes inscriptions',
  REGISTRATION_UPDATE: "Attribuer un code d'inscription",

  SESSION_GET: 'Récupérer les sessions de cours',

  SLIDES_MANAGE: 'Gérer les slides',

  STATISTICS_ABSENCE_GET: "Récupérer les statistiques d'absence des étudiants",

  STUDENT_APPLICATION_REVIEW: 'Traiter dossier inscription',
  STUDENT_CREATE: 'Créer un étudiant',
  STUDENT_DELETE: 'Supprimer un étudiant',
  STUDENT_PASSWORD_GENERATE: 'Générer mot de passe étudiant',
  STUDENT_PAYMENT_RELEASE: 'Validation paiement',
  STUDENT_STATUS_UPDATE: "Modifier le statut d'un étudiant",
  STUDENT_UPDATE: 'Modifier un étudiant',

  TEAM_MANAGE: 'Gérer le personnel',

  TEXTS_EDITION: 'Editer les textes',
};

export const penaltyTypes = {
  GROUP: 'Collective',
  SINGLE: 'Individuelle',
};

export const studentRegistrationSteps = {
  ANNEXMASTERDOCS: 'ANNEXMASTERDOCS',
  CONDITIONS: 'CONDITIONS',
  DIPLOMAS: 'DIPLOMAS',
  LEGALTUTORS: 'LEGALTUTORS',
  PERSONALINFO: 'PERSONALINFO',
  RESULT: 'RESULT',
  SCHOOLREPORTS: 'SCHOOLREPORTS',
  TRANSFERTPAPER: 'TRANSFERTPAPER',
};

export const adminRegistrationSteps = {
  DIPLOMAS: 'DIPLOMAS',
  LEGALTUTORS: 'LEGALTUTORS',
  OTHERDOCUMENTS: 'OTHERDOCUMENTS',
  PERSONALINFO: 'PERSONALINFO',
  SCHOOLREPORTS: 'SCHOOLREPORTS',
  RESULT: 'RESULT',
};

export const files = {
  birthCertificate: 'birthCertificate',
  coverLetters: 'coverLetters',
  diploma: 'diploma',
  diplomaGradeSheet: 'diplomaGradeSheet',
  englishCertificate: 'englishCertificate',
  gradeSheets: 'greatSheets',
  resume: 'resume',
  transfertPaper: 'transfertPaper',
};

export const studentStatus = {
  DISCOUNT: { code: 'RPI', label: 'Remise paiement intégral' },
  FOREIGN: { code: 'ETR', label: 'Etranger' },
  MUSTPAY: { code: 'TP', label: 'Titre Payant' },
  SCHOLARSHIP: { code: 'BRS', label: 'Boursiers' },
};

export const otheruserTypes = {
  AGENT: { code: 'agent', label: 'agent' },
  SUPERVISOR: { code: 'supervisor', label: 'superviseur' },
  VISITEUR: { code: 'visitor', label: 'visiteur' },
};

export const httpCodes = {
  OK: 200,
  CREATED: 201,
  OK_BUT_NO_CONTENT: 204,
  MOVED_PERMANENTLY: 301,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  // Used for unique fields violation
  CONFLICT: 409,
  // Used for required field violation, unallowed updates
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};


export const classCodes = [
       "LPs1s2-GC1A",
        "LPs1s2-GC1B",
        "LPs1s2-GC1C",
        "LPs1s2-GC1D",
        "LPs1s2-GC1E",
        "LPs1s2-GC1F",
        "LPs1s2-GC1G",
        "LPs1s2-GC1H",
        "LPs1s2-GC1I",
        "LPs1s2-GC1J",
        "LPs1s2-GC1K",
        "LPs1s2-GC1L",
        "LPs1s2-GC1M",
        "LPs1s2-GC1N",
        "LPs1s2-GC1O",
        "LPs1s2-GC1P",
        "LPs1s2-GC1Q",
        "LPs1s2-GC1R",
        "LPs3s4-GC2A",
        "LPs3s4-GC2B",
        "LPs3s4-GC2C",
        "LPs3s4-GC2D",
        "LPs3s4-GC2E",
        "LPs3s4-GC2F",
        "LPs3s4-GC2G",
        "LPs3s4-GC2H",
        "LPs3s4-GC2I",
        "LPs3s4-GC2J",
        "LPs3s4-GC2K",
        "LPs3s4-GC2L",
        "LPs3s4-GC2M",
        "LPs3s4-GC2N",
        "LPs3s4-GC2O",
        "LPs3s4-GC2P",
        "LPs3s4-GC2Q",
        "LPs3s4-GC2R",
        "LPs5s6-GC3A",
        "LPs5s6-GC3B",
        "LPs5s6-GC3C",
        "LPs5s6-GC3D",
        "LPs5s6-GC3E",
        "LPs5s6-GC3F",
        "LPs5s6-GC3G",
        "LPs5s6-GC3H",
        "LPs5s6-GC3I",
        "LPs5s6-GC3J",
        "LPs5s6-GC3K",
        "LPs5s6-GC3L",
        "LPs5s6-GC3M",
        "LPs5s6-GC3N",
        "LPs5s6-GC3O",
        "MPs1s2-BO1A",
        "MPs1s2-BO1B",
        "MPs3s4-BO2A",
        "MPs3s4-BO2B",
        "LPs1s2-GT1",
        "LPs3s4-GT2",
        "LPs5s6-GT3",
        "LPs1s2-GI1",
        "LPs3s4-GI2"
]